/**
 * applyStarterIcons — wire the authored Lane-C ability icons onto the registry.
 *
 * Installs the registry's icon resolver: every covered ability already
 * registered gets the served SVG path now, and every one registered later
 * (another class, a lazy TOML build) gets it in `register`. The hotbar
 * (`ActionBarSlot`) renders it via the `icon.startsWith('/')` <img> seam and
 * repaints on the registry change. Uncovered abilities keep their emoji
 * `icon` fallback untouched. Idempotent.
 *
 * The actual SVG files are emitted by `scripts/build-ability-icons.ts` into
 * `public/icons/abilities/`. This module only points metadata at those paths.
 */

import { abilityRegistry } from '../AbilityRegistry';
import { abilityIconIds, abilityIconPath } from '../../../../rendering/abilities/AbilityIconRegistry';

export function applyStarterIcons(): void {
  // Never invents ids: only abilities that are (or later become) registered
  // get a path, and the resolver never triggers lazy TOML resolution.
  const authored = new Set(abilityIconIds());
  abilityRegistry.setIconResolver((id) => (authored.has(id) ? abilityIconPath(id) : undefined));
}
